import React, { useContext, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import _ from 'lodash';

import './HorseBetting.scss';
import AppModeContext from 'src/containers/AppMode/AppMode.context';
import HorseTabs from './HorseTabs/HorseTabs';
import Category from './Category/Category';
import SearchResults from '../SearchResults/SearchResults';
import FilterButtons from './FilterButtons/FilterButtons';
import FastMode from 'src/components/HorseBetting/FastMode/FastMode';
import usePreviousValue from 'src/hooks/usePreviousValue';
import useIsMobile from 'src/hooks/useIsMobile';
import LobbyInformation from './LobbyInformation/LobbyInformation';

function HorseBettingNew() {
  const { horseRacingList, isSearching } = useSelector((state) => state.events);
  const { configs: { racing } } = useSelector((state) => state.content);
  const { optionsType } = useSelector((state) => state.filters);
  const dispatch = useDispatch();

  const [showInfo, setShowInfo] = useState(false);

  const query = new URLSearchParams(location.search);
  const prevValue = usePreviousValue(query.get('card'));
  const { t } = useTranslation();

  const { RETAIL_MODE } = useContext(AppModeContext);
  const mobile = useIsMobile();


  useEffect(() => {
    if (query.has('card') && prevValue !== query.get('card')) {
      dispatch.peripherals.getCardbyId(query.get('card'));
      dispatch.peripherals.changeBetInfo(true);
    }
  }, [query]);

  const renderCategories = () => {
    const noOptionsSelected = !optionsType?.horses && !optionsType?.dogs && !optionsType?.carriages;

    if (noOptionsSelected) {
      return (<div className="horse-betting__event-not-found">{ t('events.noEvents') }</div>);
    }

    const filteredList = _.map(horseRacingList, (elem, index) => {
      const category = JSON.parse(JSON.stringify(elem));
      if (optionsType && useIsMobile) {
        const filteredTournaments = _.filter(category.tournaments, (tournament) => {

          if ((tournament.code === 201 || tournament.code === 202) && optionsType.horses === true) {
            return true;
          } else if (tournament.code === 203 && optionsType.carriages === true) {
            return true;
          } else if (tournament.code === 204 && optionsType.dogs === true) {
            return true;
          } else {
            return false;
          }
        });

        if (filteredTournaments.length === 0) {
          return null;
        } else {
          category.tournaments = filteredTournaments;
        }
      }

      return <Category key={ elem.tournaments[0].code + index } tournaments={ category.tournaments } />;
    });

    if (_.compact(filteredList).length === 0) {
      return (<div className="horse-betting__event-not-found">{ t('events.noEvents') }</div>);
    }

    return filteredList;
  };

  return (
    isSearching && !mobile
      ?
      <SearchResults>
        <SearchResults.Racing />
      </SearchResults>
      : (
        <div className="horse-betting">
          <Helmet>
            <title>BetXchange - Racing</title>
            <meta name="description" content={ racing?.description } />
            <meta name="keywords" content={ racing?.keywords } />
          </Helmet>
          {
            RETAIL_MODE && <FastMode>
              <FastMode.Horses />
            </FastMode>
          }
          <HorseTabs toggleInfo={ () => setShowInfo(!showInfo) } showInfo={ showInfo } />
          <LobbyInformation setShowInfo={ () => setShowInfo(false) } showInfo={ showInfo } />
          {
            mobile &&
            <div className="horse-betting__filter">
              <FilterButtons />
            </div>
          }
          <div className="horse-betting__categories">
            { renderCategories() }
          </div>
        </div>
      )
  );
}

export default HorseBettingNew;
